// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"2ec0398e","990":"8ccb9d7e"}[chunkId] + ".chunk.css";
};